import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// ─── Eruda mobile DevTools (dev only) ────────────────────────────────────────
// Shows a floating ⚙️ button on-device — tap it to open console, network, etc.
// Never included in production builds (import.meta.env.DEV is false there).
// if (import.meta.env.DEV) {
//   import('eruda').then((eruda) => {
//     eruda.default.init()
//     console.log('[Eruda] Mobile DevTools ready — tap the ⚙️ button')
//   })
// }
// ─────────────────────────────────────────────────────────────────────────────

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

